import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthStore from "../../stores/AuthStore";
import { useParams } from "react-router";
import styles from "./index.module.scss";
const _403Page: React.FC = (props) => {
  const navigate = useNavigate();
  const params = useParams<{ type?: string }>();
  console.log(params.type);

  return (
    <div className={styles.container}>
      <span>很抱歉，你的访问请求被禁止</span>
      <small>{params.type === "1" ? "请联系管理员添加权限" : ""}</small>
      <button onClick={() => navigate("/sso/login")}> 返回登录</button>
    </div>
  );
};

export default _403Page;
